import {
    Autocomplete,
    Box,
    CircularProgress,
    FormControl,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    Checkbox,
    Tooltip,
} from "@mui/material";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";
import CustomTableContainer from "../../../components/table/CustomTableContainer";

const TransferSalesOrderSection = ({
    title,
    hook,
    lineItemHook,
    childRollHook,
    onLineClick,
    showCheckbox = false,
    selectedRows = [],
    onRowCheckboxClick = () => { },
    onSelectAllClick = () => { },
    isSelected = () => false,
    totalSelectedWeight = 0,
    colors,
}) => {
    const loading = hook.ddloading;
    const lineItems = lineItemHook.lineItemList || [];
    const childRolls = childRollHook.childRollList || [];

    return (
        <Grid item xl={12}>
            <Box paddingX={3}>
                <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                    {title}
                </Typography>

                {/* Autocomplete for Sales Order */}
                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                    <Autocomplete
                        size="small"
                        fullWidth
                        freeSolo
                        options={hook.salesOrderNumber}
                        value={hook.selectedSalesOrderNumber}
                        loading={loading}
                        onChange={(event, newValue) => {
                            if (typeof newValue === "string") {
                                hook.setSelectedSalesOrderNumber({ so_number: newValue });
                                hook.setSelectedSalesOrderNumberID(null);                                
                            } else if (newValue) {
                                hook.setSelectedSalesOrderNumber(newValue);
                                hook.setSelectedSalesOrderNumberID(newValue.id || null);                               
                            } else {
                                hook.setSelectedSalesOrderNumber(null);
                                hook.setSelectedSalesOrderNumberID(null);                                
                            }
                        }}
                        onInputChange={(event, newInputValue) => {
                            if (newInputValue) {
                                hook.setSelectedSalesOrderNumber({ so_number: newInputValue });
                                lineItemHook.loadSalesOrderWiseLineItemBySONumber({
                                    so_number: newInputValue,
                                });
                                childRollHook.clearChildRollList();
                            }
                        }}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option?.so_number || ""
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Sales Order Number"
                                required
                                variant="outlined"
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading ? (
                                                <CircularProgress color="inherit" size={20} />
                                            ) : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />
                        )}
                    />
                </FormControl>


                {/* Line Item Table */}
                {lineItems.length > 0 && (
                    <CustomTableContainer colors={colors}>
                        <TableContainer>
                            {loading ? (
                                <SkeletonTableLoader rows={5} columns={6} />
                            ) : (
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>S.No</TableCell>
                                            <TableCell>Item Code</TableCell>
                                            <TableCell>GSM</TableCell>
                                            <TableCell>Width</TableCell>
                                            <TableCell>Length</TableCell>
                                            <TableCell>Line No</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {lineItems.map((s) => (
                                            <TableRow key={s.s_number}>
                                                <TableCell>{s.s_number}</TableCell>
                                                <TableCell>{s.item_code}</TableCell>
                                                <TableCell>{s.gsm}</TableCell>
                                                <TableCell>
                                                    <Tooltip title="Edit Line">
                                                        <span
                                                            style={{
                                                                color: "teal",
                                                                textDecoration: "underline",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => onLineClick(s.line_no, s.width, s.length, s.item_code, s.gsm)}
                                                        >
                                                            {s.width}
                                                        </span>
                                                    </Tooltip>
                                                </TableCell>
                                                <TableCell>{s.length}</TableCell>
                                                <TableCell>{s.line_no}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            )}
                        </TableContainer>
                    </CustomTableContainer>
                )}
                {/* Child Roll Table */}
                {childRolls.length > 0 && (
                    <CustomTableContainer colors={colors}>
                        <TableContainer>
                            {loading ? (
                                <SkeletonTableLoader rows={5} columns={6} />
                            ) : (
                                <>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                {showCheckbox && (
                                                    <TableCell sx={{ width: "50px" }}>
                                                        <Checkbox
                                                            size="small"
                                                            style={{ color: "secondary" }}
                                                            indeterminate={
                                                                selectedRows.length > 0 &&
                                                                selectedRows.length < childRolls.length
                                                            }
                                                            checked={selectedRows.length === childRolls.length}
                                                            onChange={onSelectAllClick}
                                                        />
                                                    </TableCell>
                                                )}
                                                <TableCell>CHILD ROLL NUMBER</TableCell>
                                                <TableCell>MASTER REEL</TableCell>
                                                <TableCell>ITEM CODE</TableCell>
                                                <TableCell>GSM</TableCell>
                                                <TableCell>SIZE</TableCell>
                                                <TableCell>WEIGHT</TableCell>
                                                <TableCell>GRADE</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {childRolls.map((s) => (
                                                <TableRow key={s.product_id}>
                                                    {showCheckbox && (
                                                        <TableCell>
                                                            <Checkbox
                                                                size="small"
                                                                checked={isSelected(s.id_product)}
                                                                onChange={(event) =>
                                                                    onRowCheckboxClick(event, s.id_product)
                                                                }
                                                            />
                                                        </TableCell>
                                                    )}
                                                    <TableCell>{s.product_code}</TableCell>
                                                    <TableCell>{s.product_type}</TableCell>
                                                    <TableCell>{s.item_code}</TableCell>
                                                    <TableCell>{s.gsm}</TableCell>
                                                    <TableCell>
                                                        <span
                                                            style={{
                                                                color: "teal",
                                                                textDecoration: "underline",
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            {s.size}
                                                        </span>
                                                    </TableCell>
                                                    <TableCell>{s.weight}</TableCell>
                                                    <TableCell>{s.grade}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>

                                    <Box
                                        padding={1.5}
                                        display="flex"
                                        justifyContent="space-between"
                                        backgroundColor={colors.primary[400]}
                                        mt={2}
                                    >
                                        <Typography variant="h6">
                                            Selected Rows:{" "}
                                            <strong>
                                                {showCheckbox ? selectedRows.length : childRolls.length}
                                            </strong>
                                        </Typography>
                                        <Typography variant="h6">
                                            Selected Quantity: <strong>{totalSelectedWeight}</strong>
                                        </Typography>
                                    </Box>
                                </>
                            )}
                        </TableContainer>
                    </CustomTableContainer>
                )}
            </Box>
        </Grid>
    );
};

export default TransferSalesOrderSection;
